import NotificationsApi from "@/services/notifications-api";
import OrdersApi from "@/services/orders-api";

export const state = {
  type: null,
  message: null,

  notifications: [],
  orderChangedLines: [],
  unpaidInvoices: [],
  upcomingDueInvoices: [],
  invoiceWithoutRS: [],
  notificationsCount: 0
};

export const mutations = {
    success(state, message) {
        state.type = 'alert-success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'alert-danger';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    },

    setNotifications(state, payload) {
        state.notifications = payload.notifications;
        state.orderChangedLines = payload.changedOrderLines || [];
        state.unpaidInvoices = payload.unpaidInvoices || [];
        state.upcomingDueInvoices = payload.upcomingDueInvoices || [];
        state.invoiceWithoutRS = payload.invoiceWithoutRS || [];
        state.notificationsCount = payload.count || 0;
    },

     clearNotifications(state) {
        state.notifications = [];
        state.count = 0;
        state.changedOrderLines = [];
        state.unpaidInvoices = [];
        state.upcomingDueInvoices = [];
        state.invoiceWithoutRS = [];
    }

};

let notificationsIntervalId = null;


export const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    },

   startPeriodicNotificationsFetch({ dispatch }, { page = 1, pageSize = 3 }) {
        if (notificationsIntervalId) {
            clearInterval(notificationsIntervalId);
        }

        dispatch('getNotifications', { page, pageSize });

        notificationsIntervalId = setInterval(() => {
            dispatch('getNotifications', { page, pageSize });
        }, 90000);
    },


    getNotifications({ commit }, { page, pageSize }) {

        commit('clearNotifications');

        return NotificationsApi.getNotifications(page - 1, pageSize).then(data => {
        if (data) {
            commit('setNotifications', {
            notifications: data.notifications,
            count: data.count,
            changedOrderLines: data.changedOrderLines,
            unpaidInvoices: data.unpaidInvoices,
            upcomingDueInvoices: data.upcomingDueInvoices,
            invoiceWithoutRS: data.invoiceWithoutRS
            });
        }
        });
    },


     markChangedOrderLineAsViewed({ commit }, { numBc, codArt }) {
        commit('clearNotifications');

        return OrdersApi.markIsIiewedChangedOrderLine(numBc, codArt)
            .then(data => {
                commit('setNotifications', {
                notifications: data.notifications,
                count: data.count,
                changedOrderLines: data.changedOrderLines,
                unpaidInvoices: data.unpaidInvoices,
                upcomingDueInvoices: data.upcomingDueInvoices,
            upcomingDueInvoices: data.upcomingDueInvoices,
                invoiceWithoutRS: data.invoiceWithoutRS
                });
            });
    }
};


export const getters = {
  notifications: (state) => state.notifications,
  notificationsCount: (state) => state.notificationsCount,
  orderChangedLines: (state) => state.orderChangedLines,
  unpaidInvoices: (state) => state.unpaidInvoices,
  upcomingDueInvoices: (state) => state.upcomingDueInvoices,
  invoiceWithoutRS: (state) => state.invoiceWithoutRS
};
